// extracted by mini-css-extract-plugin
module.exports = {"instagramTab":"instagram_instagramTab__c1GKk","form":"instagram_form___OAPd","icon":"instagram_icon__QTiWf"};